import { Plus, Trash2 } from "lucide-react";
import { Input } from "../ui/input";
import { FRAME_KINDS, frameError, framesM2, newFrame } from "./isdeOptions";
import { nlNum } from "../../lib/isde";

const MAX = 20;
const sel = "h-11 w-full rounded-lg border border-slate-300 bg-white px-2.5 text-[14.5px] focus:outline-none focus:ring-2 focus:ring-maas/30";

const FrameRow = ({ frame, index, onChange, onRemove, canRemove, panels, mixed }) => {
  const err = frameError(frame);
  const kinds = FRAME_KINDS.filter((k) => (k.id !== "paneel" || panels) && (k.id !== "glas_hr" || mixed))
    .map((k) => (mixed && k.id === "glas" ? { ...k, label: "Kozijn met HR+++ glas" } : k));
  const field = (k, label, props) => (
    <label className="min-w-0">
      <span className="mb-1 block text-[12px] font-medium text-slate-500">{label}</span>
      <Input value={frame[k]} onChange={(e) => onChange({ ...frame, [k]: e.target.value.replace(/\D/g, "") })} data-testid={`isde-frame-${k}-${index}`}
        aria-label={`${label}, kozijn ${index + 1}`} inputMode="numeric" className="h-11 rounded-lg border-slate-300 bg-white text-[15px]" {...props} />
    </label>
  );
  return (
    <li className="rounded-xl border border-slate-200 bg-slate-50/60 p-3" data-testid={`isde-frame-${index}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[13px] font-semibold text-ink">Kozijn {index + 1}</p>
        {canRemove && (
          <button type="button" onClick={onRemove} aria-label={`Verwijder kozijn ${index + 1}`} data-testid={`isde-frame-remove-${index}`}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-400 hover:bg-white hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
        )}
      </div>
      <div className="mt-1 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <label className="col-span-2 min-w-0 sm:col-span-1">
          <span className="mb-1 block text-[12px] font-medium text-slate-500">Soort</span>
          <select value={frame.kind} onChange={(e) => onChange({ ...frame, kind: e.target.value })} className={sel} data-testid={`isde-frame-kind-${index}`} aria-label={`Soort, kozijn ${index + 1}`}>
            {kinds.map((k) => <option key={k.id} value={k.id}>{k.label}</option>)}
          </select>
        </label>
        {field("width", "Breedte (mm)", { maxLength: 5, placeholder: "1500" })}
        {field("height", "Hoogte (mm)", { maxLength: 4, placeholder: "1400" })}
        {field("quantity", "Aantal", { maxLength: 2, placeholder: "1" })}
      </div>
      {err && <p className="mt-1.5 text-[13px] font-medium text-red-600" role="alert" data-testid={`isde-frame-error-${index}`}>{err}</p>}
    </li>
  );
};

export const FrameRows = ({ frames, set, panels, mixed }) => (
  <div>
    <ul className="space-y-2.5" data-testid="isde-frames">
      {frames.map((f, i) => (
        <FrameRow key={f.key} frame={f} index={i} panels={panels} mixed={mixed} canRemove={frames.length > 1}
          onChange={(v) => set("frames", frames.map((x) => (x.key === f.key ? v : x)))}
          onRemove={() => set("frames", frames.filter((x) => x.key !== f.key))} />
      ))}
    </ul>
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
      {frames.length < MAX && (
        <button type="button" onClick={() => set("frames", [...frames, newFrame()])} data-testid="isde-frame-add"
          className="inline-flex min-h-[44px] items-center gap-2 rounded-xl px-3 text-[14.5px] font-semibold text-maas hover:bg-maas-soft">
          <Plus className="h-4 w-4" aria-hidden="true" /> Kozijn toevoegen
        </button>
      )}
      <p className="text-[14px] text-slate-600" data-testid="isde-frames-total">Opgeteld (kozijnmaten): <strong className="text-ink">{nlNum(framesM2(frames))} m²</strong></p>
    </div>
  </div>
);
